import { CommonApis } from '@eureka/services/src/apis/common.api';
import type { GetRechargeEligibilityResponse, IPackageType } from '@eureka/services/src/apis/common.api.types';
import { accountDeferred, isUserLogin } from '@eureka/utils/account';
import { packageInfoDeferred } from '@eureka/utils/package-info';
import { createSharedComposable, tryOnBeforeMount } from '@vueuse/core';
import { computed, ref } from 'vue';
import type { Account } from '@patsnap-utils/biz';
import { controlDeferred } from '@eureka/utils/control';
import type { IControl } from '@eureka/utils/control';
import { DeployEnv } from '@patsnap-utils/biz';
import { REGION } from '@eureka/utils/environment';

export const useUserPackageContext = createSharedComposable(() => {
    const packageInfo = ref<IPackageType[]>([])
    const control = ref<IControl>()
    const isLogined = ref<boolean>(false)
    const rechargeInfo = ref<GetRechargeEligibilityResponse | null>(null)

    const account = ref<Account | null>(null);

    const isOversea = [DeployEnv.US, DeployEnv.EU].includes(REGION)

    const isPersonal = computed(() => {
        return !account.value?._info?.company_id;
    })

    const isCompany = computed(() => {
        return account.value?._info?.company_id;
    })

    // 以下是套餐
    const isPro = ref<boolean>(false)

    const isFreemium = computed(() => {
        return control.value?.freemium;
    })

    const isCreditPackage = computed(() => {
        return control.value?.credit_package;
    })

    const isCountPackage = computed(() => {
        return control.value?.count_package;
    })

    const isPlgApplicableUser = computed(() => {
        return isLogined.value && isOversea && isPersonal.value && isCreditPackage.value && (isFreemium.value || isPro.value);
    })

    const isEnterprise = computed(() => {
        return !isFreemium.value && !isPro.value && isLogined.value;
    })

    const isPlgUser = computed(() => {
        return isOversea && Boolean(isFreemium.value) && Boolean(isPersonal.value);
    })

    tryOnBeforeMount(async() => {
        isLogined.value = await isUserLogin();
        if (isLogined.value) {
            packageInfo.value = await packageInfoDeferred.promise;
            rechargeInfo.value = await CommonApis.getRechargeEligibility();
            isPro.value = !!rechargeInfo.value.data.has_pay_packages;
        }
        control.value = await controlDeferred.promise;
        account.value = await accountDeferred.promise;
    })

    return {
        packageInfo,
        isPersonal,
        isEnterprise,
        isPro,
        rechargeInfo,
        account,
        control,
        isFreemium,
        isCreditPackage,
        isCountPackage,
        isLogined,
        isCompany,
        isOversea,
        isPlgUser,
        isPlgApplicableUser,
    }
})
